import { gql } from '@apollo/client';

export const CREATE_PBI_REPORT_MUTATOR = gql`
  mutation CreatePBIReportMutation(
    $group_id: String!
    $company_id: String!
    $pbi_report_data: JSON!
    $user_email: String!
  ) {
    createPBIReport(
      group_id: $group_id
      company_id: $company_id
      pbi_report_data: $pbi_report_data
      user_email: $user_email
    )
  }
`;

export const UPDATE_PBI_REPORT_MUTATOR = gql`
  mutation UpdatePBIReportMutation(
    $group_id: String!
    $company_id: String!
    $pbi_report_id: String!
    $updated_pbi_report: JSON!
    $original_pbi_report: JSON!
    $user_email: String!
  ) {
    updatePBIReport(
      group_id: $group_id
      company_id: $company_id
      pbi_report_id: $pbi_report_id
      updated_pbi_report: $updated_pbi_report
      original_pbi_report: $original_pbi_report
      user_email: $user_email
    )
  }
`;

export const DELETE_PBI_REPORT_MUTATOR = gql`
  mutation DeletePBIReportMutation(
    $group_id: String!
    $company_id: String!
    $pbi_report_id: String!
    $user_email: String!
  ) {
    deletePBIReport(
      group_id: $group_id
      company_id: $company_id
      pbi_report_id: $pbi_report_id
      user_email: $user_email
    )
  }
`;
